export default "__VITE_ASSET__8dd652f1__"